import React , {useEffect, useState } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
} from "@chakra-ui/react";
import { Box, Grid } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles"; 
import * as Actions from "../../store/action/policy";
import Skeleton from '@mui/material/Skeleton';
import {getLabelClass, renderInputOrSpan} from "../../utils/formUtils";
import {toggleExpansion} from "../../utils/toggleExpansion";

const useStyles = makeStyles((theme) => ({
  labelInput: {
    fontFamily: "Poppins",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "18px",
    textAlign: "left",
    color: "rgba(70, 78, 95, 1)",
    marginBottom: "10px",
  },
  styleInput: {
    borderRadius: "4px",
    border: 0,
    background: "rgba(243, 246, 249, 1)",
    height: "36px",
    width: "241px",
    padding: "14px",
    fontFamily: "Poppins",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "18px",
    textAlign: "left",
    color: "rgba(70, 78, 95, 1)",
  },
  paper: {
    width: "100%",
    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.06)",
  },

  customAccordionItem : {
    width: "100%",
    marginBottom: "20px",
    borderRadius: "11px",
    border:`1px solid rgba(187, 200, 8, 1)`,
      // "&_expanded" : {
      // border: "1px solid rgba(187, 200, 8, 1)",
      // },
    },
  styleSpan:{
    color: 'rgba(70, 78, 95, 1)',
    fontSize: '12px',
    fontWeight: 400,
    fontFamily: 'Poppins'
  },
  styleSpanLabel:{
    color: 'rgba(70, 78, 95, 1)',
    fontSize: '12px',
    fontWeight: 600,
    fontFamily: 'Poppins'
  },
  expanded: {
    border: "none",
  },
    
}));

function VehiculeSection(props) {
  const classes = useStyles();
  const [goodsData, setGoodsData] = useState([]);  
  const [loading, setLoading] = useState(true);
  const listOfCars = props.listOfCars ;
  const renderAsSpans = props.renderAsSpans 
  const [expandedItems, setExpandedItems] = useState(new Set([0]));

  const getRegistration  = (goodCaracteristique) => {  
    const array =  goodCaracteristique.find(caracteristique => caracteristique.key  === "License_plate"); 
    if(array){
      return array.value
    } 
    else { return "N/A"}
  }

  const getRegistration_date  = (goodCaracteristique) => {
    // le flux batch MAE stocke la date sous la cle "Firstcirculationdate" (ISO)
    const array =  goodCaracteristique.find(caracteristique => caracteristique.key  === "Registration_date")
      || goodCaracteristique.find(caracteristique => caracteristique.key  === "Firstcirculationdate");
    if(array){
      if(typeof array.value === "string" && array.value.includes("T")){
        const date = new Date(array.value)
        if(!isNaN(date)){
          return date.toLocaleDateString("fr-FR")
        }
      }
      return array.value
    }
    else { return "N/A"}
  }

  const getBrand  = (goodCaracteristique) => {
    const array =  goodCaracteristique.find(caracteristique => caracteristique.key  === "Brand"); 
    if(array){
      return array.value
    } 
    else { return "N/A"}
  }
  
  const getModel  = (goodCaracteristique) => {  
    const array =  goodCaracteristique.find(caracteristique => caracteristique.key  === "Model"); 
    if(array){
      return array.value
    } 
    else { return "N/A"}
  }
  const getVin  = (goodCaracteristique) => {
    // le flux batch MAE stocke le chassis sous la cle "Chassisnumber"
    const array =  goodCaracteristique.find(caracteristique => caracteristique.key  === "Vin")
      || goodCaracteristique.find(caracteristique => caracteristique.key  === "Chassisnumber");
    if(array){
      return array.value
    }
    else { return "N/A"}
  }

  const getMarket_value  = (goodCaracteristique) => {  
    const array =  goodCaracteristique.find(caracteristique => caracteristique.key  === "Market_value"); 
    if(array){
      return array.value
    } 
    else { return "N/A"}
  }

  const getPOWER_value  = (goodCaracteristique) => {  
    const array =  goodCaracteristique.find(caracteristique => caracteristique.key  === "Power"); 
    if(array){
      return array.value
    } 
    else { return "N/A"}
  }

  const getNEW_VALUE_value  = (goodCaracteristique) => {  
    const array =  goodCaracteristique.find(caracteristique => caracteristique.key  === "New_value"); 
    if(array){
      return array.value
    } 
    else { return "N/A"}
  }
  const getGoodDetails = async (good  ) => {
    
    try {
      const goodDetails = await Promise.all(good.map(goodUid => Actions.getGoodDetails(goodUid)));
      return goodDetails; 
    } catch (error) {
      console.error(`Error fetching goods : ${error}`);
      return null;
    }
  };
 

  const fetchGoods = async () => {
    setLoading(true);  
    const goods = await getGoodDetails(listOfCars.map(good => good.goodUid));
    const filtered = goods.filter(item => item !== undefined);
    const filteredGoods = filtered.filter(item => item?.type === "VEHICULE");
    setGoodsData(Array.isArray(filteredGoods) ? filteredGoods : [filteredGoods]);
    setLoading(false);
  };
  useEffect(() => {
   
    fetchGoods();
  }, []);


  return (
    <div style={{ padding: "40px" }}>
    <Accordion defaultIndex={[0]}    allowMultiple >
    {loading ? 
      <>
      {[...Array(3)].map((row, index) => {
        return (
            <AccordionItem className={`${classes.customAccordionItem} ${renderAsSpans ? classes.expanded : ''}`} key={index}>
              <AccordionButton
                  onClick={() => toggleExpansion(index, expandedItems, setExpandedItems)}
                  style={{ height: "47px", border: "none", background: "rgba(249, 249, 249, 1)", padding: "10px", borderRadius: "11px" }}  >
            <AccordionIcon size="30px" style={{ backgroundColor: "rgba(240, 243, 199, 1)", width: "25px", height: "25px", borderRadius: "5px", color: "rgba(187, 200, 8, 1)" }} />
            <Skeleton  size="30px" animation="wave" width={160} height={30}/>
          </AccordionButton>
          <AccordionPanel style={{ width: "100%", background: 'rgba(255, 255, 255, 1)', padding: '30px' , borderRadius: "11px" }}>
              <Grid container style={{justifyContent: 'start' , marginBottom :'10px'}}  spacing={2} >
                  <Grid item  > 
                      <div>
                      <div className={getLabelClass(renderAsSpans, classes)} style={{marginRight: "40px"}}>Immatriculation</div>
                        <Skeleton animation="wave" width={241} height={50}/>
                      </div>
                  </Grid>
                  <Grid item  > 
                      <div>
                      <div className={getLabelClass(renderAsSpans, classes)} style={{marginRight: "40px"}}>Marque</div>
                        <Skeleton animation="wave" width={241} height={50}/>
                      </div>
                  </Grid>
                  <Grid item  > 
                      <div>
                      <div className={getLabelClass(renderAsSpans, classes)} style={{marginRight: "40px"}}>Modèle</div>
                        <Skeleton animation="wave" width={241} height={50}/>
                      </div>
                  </Grid>
                  <Grid item  > 
                      <div>
                      <div className={getLabelClass(renderAsSpans, classes)} style={{marginRight: "40px"}}>Numéro Châssis</div>
                        <Skeleton animation="wave" width={241} height={50}/>
                      </div>
                  </Grid>
                  
                  <Grid item  > 
                      <div>
                      <div className={getLabelClass(renderAsSpans, classes)} style={{marginRight: "40px"}}>Valeur Venale</div>
                        <Skeleton animation="wave" width={241} height={50}/>
                      </div>
                  </Grid>
      
                  <Grid item  > 
                    <div>
                    <div className={getLabelClass(renderAsSpans, classes)} style={{marginRight: "40px"}}>Tier associé</div>
                    <Skeleton animation="wave" width={241} height={50}/>
                    </div>
                  </Grid>
                  
                   
          </Grid>
            
          </AccordionPanel>
        </AccordionItem>
        )})}
        </>
        :
       <>
    
    {
      goodsData.map((goods, index) => (

          <AccordionItem className={`${classes.customAccordionItem} ${renderAsSpans ? classes.expanded : ''}`} key={index}>
            <AccordionButton
                onClick={() => toggleExpansion(index, expandedItems, setExpandedItems)}
                style={{ height: "47px", border: "none", background: "rgba(249, 249, 249, 1)", padding: "10px", borderRadius: "11px" }}  >
                <AccordionIcon size="30px" style={{ backgroundColor: "rgba(240, 243, 199, 1)", width: "25px", height: "25px", borderRadius: "5px", color: "rgba(187, 200, 8, 1)" }} />
                <Box as="span"   textAlign='left' marginLeft='20px' style={{ color: "rgba(0, 34, 38, 1)", fontSize: '15px', fontWeight: 500, lineHeight: '21px', fontFamily: 'Poppins', }}>
                    {getRegistration(goods.goodCaracteristique)}
                </Box>
              </AccordionButton>
              <AccordionPanel style={{ width: "100%", background: 'rgba(255, 255, 255, 1)', padding: '30px' , borderRadius: "11px" }}>
              <Grid container  style={{justifyContent: 'start' , marginBottom :'10px'}}  spacing={2} >
                      <Grid item  > 
                      <div>
                    <div className={getLabelClass(renderAsSpans, classes)} style={{marginRight: "40px"}}>Immatriculation</div>
                    {/*<input*/}
                    {/*  className={classes.styleInput}*/}
                    {/*  type="text"*/}
                    {/*  name="immatriculation"*/}
                    {/*  value={getRegistration(goods.goodCaracteristique)}*/}
                    {/*  disabled*/}
                    {/*/>*/}
                        {renderInputOrSpan(renderAsSpans, getRegistration(goods.goodCaracteristique) || "N/A", classes)}
                  </div>
                      </Grid>
                      <Grid item  > 
                      <div>
                      <div className={getLabelClass(renderAsSpans, classes)} style={{marginRight: "40px"}}>Marque</div>
                    {/*<input*/}
                    {/*  className={classes.styleInput}*/}
                    {/*  type="text"*/}
                    {/*  name="marque"*/}
                    {/*  value={getBrand(goods.goodCaracteristique)}*/}
                    {/*  disabled*/}
                    {/*/>*/}
                        {renderInputOrSpan(renderAsSpans, getBrand(goods.goodCaracteristique) || "N/A", classes)}
                  </div>
                      </Grid>
                      <Grid item  > 
                      <div>
                    <div className={getLabelClass(renderAsSpans, classes)} style={{marginRight: "40px"}}>Modèle</div>
                    {/*<input*/}
                    {/*  className={classes.styleInput}*/}
                    {/*  type="text"*/}
                    {/*  name="modele"*/}
                    {/*  value={getModel(goods.goodCaracteristique)}*/}
                    {/*  disabled*/}
                    {/*/>*/}
                        {renderInputOrSpan(renderAsSpans, getModel(goods.goodCaracteristique) || "N/A", classes)}
                  </div>
                      </Grid>
                      <Grid item  > 
                      <div>
                    <div className={getLabelClass(renderAsSpans, classes)} style={{marginRight: "40px"}}>Numéro Châssis</div>
                      {/*<input*/}
                      {/*  className={classes.styleInput}*/}
                      {/*  type="text"*/}
                      {/*  name="vin"*/}
                      {/*  value={getVin(goods.goodCaracteristique)}*/}
                      {/*  disabled*/}
                      {/*/>*/}
                        {renderInputOrSpan(renderAsSpans, getVin(goods.goodCaracteristique) || "N/A", classes)}
                    </div>
                      </Grid>
                      <Grid item  > 
                      <div>
                        <div className={getLabelClass(renderAsSpans, classes)} style={{marginRight: "40px"}}>Puissance</div>
                          {/*<input*/}
                          {/*  className={classes.styleInput}*/}
                          {/*  type="text"*/}
                          {/*  name="vin"*/}
                          {/*  value={getMarket_value(goods.goodCaracteristique)}*/}
                          {/*  disabled*/}
                          {/*/>*/}
                            {renderInputOrSpan(renderAsSpans, getPOWER_value(goods.goodCaracteristique) || "N/A", classes)}
                        </div>
                      </Grid>
                      <Grid item  > 
                      <div>
                        <div className={getLabelClass(renderAsSpans, classes)} style={{marginRight: "40px"}}>Valeur Venale</div>
                          {/*<input*/}
                          {/*  className={classes.styleInput}*/}
                          {/*  type="text"*/}
                          {/*  name="vin"*/}
                          {/*  value={getMarket_value(goods.goodCaracteristique)}*/}
                          {/*  disabled*/}
                          {/*/>*/}
                            {renderInputOrSpan(renderAsSpans, getMarket_value(goods.goodCaracteristique) || "N/A", classes)}
                        </div>
                      </Grid>
                      <Grid item  > 
                      <div>
                        <div className={getLabelClass(renderAsSpans, classes)} style={{marginRight: "40px"}}>Valeur Neuf</div>
                          {/*<input*/}
                          {/*  className={classes.styleInput}*/}
                          {/*  type="text"*/}
                          {/*  name="vin"*/}
                          {/*  value={getMarket_value(goods.goodCaracteristique)}*/}
                          {/*  disabled*/}
                          {/*/>*/}
                            {renderInputOrSpan(renderAsSpans, getNEW_VALUE_value(goods.goodCaracteristique) || "N/A", classes)}
                        </div>
                      </Grid>
                      <Grid item  >
                      <div>
                        <div className={getLabelClass(renderAsSpans, classes)} style={{marginRight: "40px"}}>Date de mise en circulation</div>
                            {renderInputOrSpan(renderAsSpans, getRegistration_date(goods.goodCaracteristique) || "N/A", classes)}
                        </div>
                      </Grid>
                      {/* <Grid item  >
                      <div>
                    <div className={getLabelClass(renderAsSpans, classes)}>Tier associé</div>
                    <input
                      type="text"
                      style={{
                        borderRadius: "4px",
                        border: 0,
                        background: "rgba(243, 246, 249, 1)",
                        height: "36px",
                        width: "241px",
                        padding: "14px",
                        fontFamily: "Poppins",
                        fontSize: "12px",
                        fontWeight: 400,
                        lineHeight: "18px",
                        textAlign: "left",
                        color: "#BBC808",
                      }}
                      name="tier"
                      value={goods.tier}
                      disabled
                    />
                  </div>

                      </Grid> */}
                      
              </Grid>
           
                
              </AccordionPanel>
            </AccordionItem>
       
      ))
    }</>}
     </Accordion>
     
  </div>
  );
}

export default VehiculeSection;
